var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loading"},[_c('p',[_vm._v("Simulando")]),_c('div',{staticClass:"dot-flashing"})])])}]

export { render, staticRenderFns }